// eslint-disable-next-line @github-ui/github-monorepo/filename-convention
import {JetBrains as SvgJetBrains, VSCode as SvgVsCode} from '@github-ui/brand-core/ide-icons'

import type {ProductAnnouncementData} from './../components/ProductAnnouncement/ProductAnnouncement.types'
import ImageModalTab1Dark from './assets/ccaOnboarding/modal/tab1-dark.webp'
import ImageModalTab1Light from './assets/ccaOnboarding/modal/tab1-light.webp'
import ImageModalTab2Dark from './assets/ccaOnboarding/modal/tab2-dark.webp'
import ImageModalTab2Light from './assets/ccaOnboarding/modal/tab2-light.webp'
import ImageModalTab3Dark from './assets/ccaOnboarding/modal/tab3-dark.webp'
import ImageModalTab3Light from './assets/ccaOnboarding/modal/tab3-light.webp'

const getData = (): ProductAnnouncementData => {
  return {
    modal: {
      title: 'Get started with Copilot',
      label: 'Copilot Pro+',
      body: 'Connect Copilot to your workflow and put agents to work on real tasks.',
      cta1: {
        label: 'Get started',
      },
      tabs: [
        {
          title: 'Copilot works where you work',
          heading: 'Copilot works where you work',
          description:
            'Work in your CLI, build in your IDE, and ship on GitHub. Copilot runs across your entire toolchain.',
          visual: {
            type: 'image',
            src: {
              light: ImageModalTab1Light,
              dark: ImageModalTab1Dark,
            },
            alt: 'Placeholder preview for setting up Copilot across the CLI and IDE.',
          },
          dropdown: {
            label: 'Set up where you work',
            sections: [
              {
                type: 'input',
                label: 'Set up in CLI',
                value: 'brew install copilot-cli',
                copyButtonLabel: 'Copy the Copilot CLI install command',
              },
              {
                type: 'items',
                heading: 'Set up in IDE',
                items: [
                  {
                    id: 'vscode',
                    label: 'VS Code',
                    href: 'https://marketplace.visualstudio.com/items?itemName=GitHub.copilot-chat',
                    isNewWindow: true,
                    icon: {
                      src: SvgVsCode,
                      alt: '',
                    },
                  },
                  {
                    id: 'jetbrains',
                    label: 'JetBrains',
                    href: 'https://plugins.jetbrains.com/plugin/17718-github-copilot--your-ai-pair-programmer',
                    isNewWindow: true,
                    icon: {
                      src: SvgJetBrains,
                      alt: '',
                    },
                  },
                  {
                    id: 'more',
                    label: 'More',
                    href: `https://docs.github.com/en/copilot/how-tos/set-up/install-copilot-extension`,
                    isNewWindow: true,
                    icon: 'KebabHorizontalIcon',
                  },
                ],
              },
            ],
          },
        },
        {
          title: 'Delegate your work to an agent',
          heading: 'Delegate your work to an agent',
          description: 'Plan a well-scoped change, delegate the work to an agent, and review the results.',
          visual: {
            type: 'image',
            src: {
              light: ImageModalTab2Light,
              dark: ImageModalTab2Dark,
            },
            alt: 'Placeholder preview for delegating work to a Copilot agent.',
          },
          cta2: {
            label: 'Start with agents',
          },
        },
        {
          title: 'Customize your agent',
          heading: 'Customize your agent',
          description: 'Use third-party agents, connect MCPs, or create custom agents to add new skills and context.',
          visual: {
            type: 'image',
            src: {
              light: ImageModalTab3Light,
              dark: ImageModalTab3Dark,
            },
            alt: 'Placeholder preview for customizing a Copilot agent.',
          },
          cta2: {
            label: 'Create a custom agent',
          },
        },
      ],
    },
  }
}

export default getData
